module.exports = __webpack_public_path__ + "img/jimmy.f952413c.jpg";